import { formatProfileDate } from '../lib/profile-dates';

export const parseJson = (value, fallback = {}) => {
  if (value && typeof value === 'object') return value;
  if (typeof value !== 'string' || value.trim() === '') return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const normalizeMemory = (memory) => {
  const metadata = parseJson(memory.metadata, {});
  const content = (memory.content || []).map((item) => parseJson(item.data, item));

  return {
    id: memory.id,
    profileId: memory.profile_id,
    author: memory.display_author || memory.author,
    shortDescription: memory.short_description || '',
    longDescription: memory.long_description || '',
    metadata,
    dateOfInsert: memory.date_of_insert,
    dateOfModification: memory.date_of_modification,
    commentCount: Number(memory.comment_count || 0),
    content,
  };
};

export const normalizeProfile = (profile) => {
  const settings = {
    allowAnonymous: true,
    moderationMode: 'moderated',
    ...parseJson(profile?.settings, {}),
  };

  return {
    id: profile?.id || null,
    slug: profile?.slug || '',
    name: profile?.name || '',
    avatar: profile?.avatar || null,
    birthDate: profile?.birth_date || null,
    deathDate: profile?.death_date || null,
    motto: profile?.motto || '',
    description: profile?.description || '',
    metadata: parseJson(profile?.metadata, {}),
    settings,
  };
};

export const ROMAN_SLUG = 'mgr-roman-kalab-riha-2024-30-11';
export const profilePath = (slug) => (slug === ROMAN_SLUG ? '/mgr-Roman-Kalab-Riha-2024-30-11' : `/p/${slug}`);
export const profileYears = (profile) =>
  [profile.birthDate, profile.deathDate]
    .map((date) => formatProfileDate(date, true))
    .filter(Boolean)
    .join(' – ');
export const profileDates = (profile) =>
  [profile.birthDate, profile.deathDate]
    .map((date) => formatProfileDate(date))
    .filter(Boolean)
    .join(' – ');
export const initials = (name) =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('');

export const getMemoryText = (memory) => {
  const type = memory?.metadata?.type;
  if (type === 'youtube') return { primaryText: memory.longDescription || '', secondaryText: memory.shortDescription || 'Video na YouTube' };
  if (type === 'video') return { primaryText: memory.longDescription || '', secondaryText: memory.shortDescription || 'Video' };
  let primaryText = memory?.longDescription || '';
  let secondaryText = memory?.shortDescription || '';

  if (type === 'quotation') {
    primaryText = memory?.shortDescription || '';
    secondaryText = memory?.longDescription || '';
  }

  if (type === 'image') {
    primaryText = memory?.longDescription || '';
    secondaryText = memory?.shortDescription || '';
  }

  if (!primaryText && secondaryText) {
    primaryText = secondaryText;
    secondaryText = '';
  }

  return { primaryText, secondaryText };
};

export const getHostedVideo = (memory) => {
  if (memory?.metadata?.type !== 'video') return null;
  const data = memory.content?.[0];
  if (!/^[a-f0-9]{64}\.(mp4|webm)$/.test(data?.video || '')) return null;
  return { url: data.urls?.video || `/media/${data.video}`, poster: data.urls?.poster || (/^[a-f0-9]{64}-poster\.jpg$/.test(data.poster || '') ? `/media/${data.poster}` : undefined) };
};

export const getImagePaths = (memory) => {
  const content = memory?.content?.[0] || {};
  return {
    original: content.urls?.original || (content.original ? `/images/${content.original}` : null),
    reduced: content.urls?.reduced || (content.reduced ? `/images/${content.reduced}` : null),
    thumbnail: content.urls?.thumbnail || (content.thumbnail ? `/images/${content.thumbnail}` : null),
  };
};
